import { ShieldCheck, ReceiptEuro, Clock } from "lucide-react";

const SEALS = [
  {
    icon: ShieldCheck,
    title: "Haftpflichtversichert",
    text: "Betriebshaftpflicht über die Generali Deutschland AG",
    id: "versicherung",
  },
  {
    icon: ReceiptEuro,
    title: "Festpreis-Zusage",
    text: "Verbindlicher Preis nach Online-Anfrage oder Besichtigung",
    id: "festpreis",
  },
  {
    icon: Clock,
    title: "24/7 erreichbar",
    text: "Auch abends und am Wochenende – auf Wunsch kurzfristig",
    id: "erreichbarkeit",
  },
];

export const TrustBar = () => (
  <section className="bg-white border-b border-[#E2E8F0]" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-7">
      {SEALS.map((s) => (
        <div key={s.id} data-testid={`trust-seal-${s.id}`} className="flex gap-4">
          <span className="shrink-0 h-11 w-11 rounded-full bg-[#EBF5FF] border border-[#145DA0]/20 flex items-center justify-center">
            <s.icon size={19} strokeWidth={1.8} className="text-[#145DA0]" />
          </span>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-[#0F172A] leading-snug">{s.title}</div>
            <div className="mt-1 text-xs md:text-sm text-[#64748B] leading-relaxed">{s.text}</div>
          </div>
        </div>
      ))}
    </div>
  </section>
);
